import { z } from 'zod';
import { baseTaskSchema } from '../schema.base.js';
import { selectableCharacterInput } from './input.selectable-character.js';
import { markCharactersWhitespaceInput } from './input.whitespace.js';

const selectAnswersMarkCharactersTaskSchema = baseTaskSchema.extend({
  taskType: z.literal("SelectAnswers"),
  answerType: z.literal("MarkCharacters"),
  contents: z.array(z.array(z.preprocess(it => {
    if (!it || typeof it !== "object" || !("character" in it) || typeof it.character !== "string") {
      return it;
    }
    if (!it.character.trim()) {
      return {
        ...it,
        type: "Whitespace"
      };
    }
    return it;
  }, z.union([markCharactersWhitespaceInput.schema, selectableCharacterInput.schema]))))
}).transform(({
  contents,
  ...rest
}) => ({
  ...rest,
  content: contents.map((word, wi) => word.map((it, ci) => "nodeType" in it ? it : selectableCharacterInput.postprocessSchemaInput(it, {
    taskId: rest.id,
    index: wi * 1000 + ci
  })))
  // STEP: Flatten words into a single list of inputs and ensure that there
  // is at least a space as whitespace between two words (In case they're
  // not separated by newlines.)
  .flatMap((word, index, words) => {
    const lastCharacter = word.at(-1);
    const nextCharacter = words[index + 1]?.[0];
    if (lastCharacter?.nodeType === "mark-characters-whitespace" || nextCharacter?.nodeType === "mark-characters-whitespace") {
      return word;
    } else {
      return [...word, {
        id: "whitespace",
        type: "Whitespace",
        nodeType: "mark-characters-whitespace",
        as: "space"
      }];
    }
  })
}));

export { selectAnswersMarkCharactersTaskSchema };
//# sourceMappingURL=_schema.js.map
